export class Accordion {
    constructor() {
        const accordions = document.querySelectorAll("[data-accordion-id]");

        accordions.forEach((accordion) => {
            accordion.addEventListener("click", function(e)  {
                const {accordionId} = accordion.dataset;

                this.classList.toggle("active");
                const panel = document.querySelector(`[data-accordion="${accordionId}"]`);

                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + 100 + "px";
                }
            });
        });
    }
}